import { Controller } from '@hotwired/stimulus'

// ClickhouseDrillDownRow
// This controller is used to handle the expand/collapse of a row in the drilldown table.
// It works in conjunction with TurboStream defined in ClickhouseDrillDownable
//
// Expand = calls turbo url which appends <tr>s to the table below the row
// Collapse = removes all subsequent rows tagged with this row's parent id at any deeper depth
//
// Everything else is just showing/hiding chevrons and loading spinner
//
// Styles: clickhouse-drill-down-table.scss
export default class extends Controller {
    #isExpanded = false

    // Drilldown expand/collapse using fetch+Turbo Streams where a parent row
    // DOM ID is passed to the Rails controller and Turbo Stream response
    // handles appending the rows after the parent row
    expand(event) {
        if (this.#isExpanded) {
            this.#collapse()
            return
        }

        this.#showIcon('loading')
        this.#isExpanded = true

        // Request Turbo Stream to insert rows after parent
        // FIXME: Use @rails/request.js here when we upgrade to Turbo 7->8
        // with responseKind: 'turbo-stream' we don't have to call Turbo.renderStreamMessage
        // or pass any headers
        fetch(event.params.url, {
            headers: {
                Accept: 'text/vnd.turbo-stream.html',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || '',
            },
        })
            .then((r) => r.text())
            .then((html) => {
                window.Turbo.renderStreamMessage(html)

                this.#showIcon('collapse')
            })
            .catch(() => {
                // Revert state on failure
                this.#isExpanded = false
                this.#showIcon('expand')
            })
    }

    #collapse() {
        this.#removeNestedRows(this.#parentRow())
        this.#showIcon('expand')
        this.#isExpanded = false
    }

    #parentRow() {
        // Inbound RTB expand attaches this controller to the <td>; drill-down rows use <tr>.
        return this.element.closest('tr')
    }

    #removeNestedRows(targetRow) {
        const parentId = targetRow.id
        let next = targetRow.nextElementSibling
        while (next && next.dataset && next.dataset.parentRow === parentId) {
            const toRemove = next
            this.#removeNestedRows(toRemove) // Recursively remove all nested rows
            next = next.nextElementSibling
            toRemove.remove()
        }
    }

    #showIcon(icon) {
        // Set data-chevron-loading-icons-visible-icon-value="expand | collapse | loading"
        // See chevron_loading_icons_controller.js
        this.element.dataset.chevronLoadingIconsVisibleIconValue = icon
    }
}
